/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Newsletter_Optin_ErrorInputs */



/**
* | output |
* | --- |
* | "Could not update your newsletter subscription. Please try again." |
*
* @param {Newsletter_Optin_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const newsletter_optin_error = /** @type {((inputs?: Newsletter_Optin_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Newsletter_Optin_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Newsletter-Einstellung konnte nicht geändert werden. Bitte erneut versuchen.")
	return /** @type {LocalizedString} */ ("Could not update your newsletter subscription. Please try again.")
});